const isFirstSuffix = (restOf10: number, restOf100: number): boolean =>
  restOf10 === 1 && restOf100 !== 11;
const isSecondSuffix = (restOf10: number, restOf100: number): boolean =>
  restOf10 === 2 && restOf100 !== 12;
const isThirdSuffix = (restOf10: number, restOf100: number): boolean =>
  restOf10 === 3 && restOf100 !== 13;

const getSuffix = (restOf10: number, restOf100: number): string => {
  if (isFirstSuffix(restOf10, restOf100)) {
    return 'st';
  }

  if (isSecondSuffix(restOf10, restOf100)) {
    return 'nd';
  }

  if (isThirdSuffix(restOf10, restOf100)) {
    return 'rd';
  }

  return 'th';
};

/**
 * Transform number to ordinal representation
 *
 * ### Example (es module)
 * ```js
 * console.log(ordinalSuffixOf(1)) // => 1st
 * console.log(ordinalSuffixOf(2)) // => 2nd
 * console.log(ordinalSuffixOf(3)) // => 3rd
 * console.log(ordinalSuffixOf(25)) // => 25th
 * console.log(ordinalSuffixOf(1001)) // => 1001st
 * ```
 */
export const ordinalSuffixOf = (num: number): string => {
  const restOf10 = num % 10;
  const restOf100 = num % 100;

  return num + getSuffix(restOf10, restOf100);
};

/**
 * Transform number to into currency format
 */
export const currencyFormat = (
  num: number,
  currency = '$',
  showSign: boolean = false
): string => {
  const million = 10 ** 6;
  const thousand = 10 ** 3;
  const sign = Math.sign(num);
  const signSymbol = showSign && sign === -1 ? '-' : '';

  const abs = Math.abs(num);

  const isNumberThousand = abs < million;
  const isNumberMillion = abs >= million;

  if (isNumberThousand) {
    return signSymbol + currency + Math.round(abs / thousand) + 'k';
  } else if (isNumberMillion) {
    return signSymbol + currency + Math.round(abs / million) + 'm';
  } else {
    return signSymbol + currency + Math.round(abs / million);
  }
};
